module.exports = __webpack_public_path__ + "img/py_jb_connect.1fb3cc59.png";